import { useCallback, useState } from 'react';
import { useAuthenticatedApiContext } from '../api/useApiClient';
import { Tenant } from '../models/TenantModels';
import { useAsync } from './useAsync';

export const useTenantHook = () => {
  const [tenant, setTenant] = useState<Tenant | undefined>();
  const apiClient = useAuthenticatedApiContext();

  const loadTenant = useAsync(
    useCallback(async (): Promise<void> => {
      /* istanbul ignore next */
      return apiClient.getTenant().then((res) => setTenant(res));
    }, [apiClient]),
    { autoReset: true }
  );

  return { loadTenant, tenant };
};
